<template>

    <div class="user">
     
     
        <div class="ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>筛选条件</span>
          </div>
        </div>
        <el-form :inline="false" :model="form_s" class="demo-form-inline" label-width="100px">
          <div class="flex ba_f" >
            <el-form-item label="查询日期：" class="mar_t20">
              <div class="flex-bet">
                <div>
                  <el-radio-group  v-model="form_s.timeType" @change="selectType">
                    <el-radio-button label="1">今天</el-radio-button>
                    <el-radio-button label="2">近七天</el-radio-button>
                    <el-radio-button label="3">近十五天</el-radio-button>
                    <el-radio-button label="4">自定义时间</el-radio-button>
       
                  </el-radio-group>
                  <span class="mar_l20" v-if="form_s.timeType=='4'">
                  <el-date-picker v-model="form_s.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期" format="yyyy年MM月dd日" :picker-options="pickerOptions" @change="selectType"></el-date-picker>
                </span>
     
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="flex ba_f" >

            <!-- <el-form-item label="从哪入库：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_s.supply_id" placeholder="请选择" @change="changeStore" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item> -->


            <el-form-item label="入库到哪：" width="300">
              <div class="mar_l20">
                <el-select v-model="form_s.t_supply_id" placeholder="请选择" @change="changeStore" filterable>
                  <el-option v-for="item in supplyArr" :key="item.supply_id" :label="item.name+'(标签:'+item.kmdGrade.name+')'+'(ID:'+item.supply_id+')'"
                            :value="item.supply_id"></el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="选择产品："  width="300">
              <div class="mar_l20">
                <el-select v-model="form_s.product_sku_id" placeholder="请选择" @change="changeStore" filterable>
                  <el-option v-for="item in productArr" :key="item.product_sku_id" 
                  :label="item.product_name+'(规格:'+item.spec+':'+')'+'(ID:'+item.product_sku_id+')'"
                            :value="item.product_sku_id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>


       
        </el-form>
      </div>


      <div class="mar_t20 ba_f outmain">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>整体看板</span>
          </div>
          <!--    <div class="fon_12 ab r0 mar_r10 color_9">更新时间：2020-09-04 13:32:59</div>-->
        </div>
        <div class="main-icon flex t_l mar_t20">
        

          <div class="flex-1 t_l pad_20 borderBG mar_r20">
            <div class="flex-bet flex-y-top">
              <div>
                <p class="title6 fon_14">进货量</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ notesRecord.total_num || 0 }}</p>

              </div>
            </div>
          </div>

    
        </div>
        <div   v-if="echarts2_option.xAxis && echarts2_option.xAxis.data" id="zhentiEch" style="height: 360px;" class="mar_t20"></div>
        <div v-else>未获取到数据</div>
    </div>
     
        <!--添加任务-->
      <!-- <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="供应商/厂家/供应商">
            <el-input placeholder="请输入供应商/厂家/供应商" v-model="formInline.search">
          
            </el-input>
          </el-form-item>

          <el-form-item label="入库单号">
            <el-input placeholder="请输入入库单号" v-model="formInline.numb">
          
            </el-input>
          </el-form-item>


          <el-form-item label="库位">
            <el-input placeholder="请输入库位" v-model="formInline.kw">
          
            </el-input>
          </el-form-item>

          
          <el-form-item label="起始时间">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            size="small"
            v-model="formInline.create_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
      </el-form-item>


          <el-form-item >
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          </el-form-item>
  
        </el-form>
      </div>
   -->
   
  

      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column prop="supply.name" label="供应商/商家ID-从哪入库"></el-table-column>
                <el-table-column prop="t_supply.name" label="供应商/商家ID-入库到哪"></el-table-column>
  
              
                <el-table-column prop="warehouse_wk_name" label="库位"></el-table-column>
                <el-table-column prop="warehouse_management_id" label="入库ID"></el-table-column>
                <el-table-column prop="warehouse_management.inboundOrderNumber" label="入库单号"></el-table-column>

                <el-table-column prop="type" label="类型">
                    <template #default="{row}">
                        {{ 
                        row.type === 0 ? '市场采购' : 
                        row.type === 1 ? '供应商采购' : 
                        row.type === 2 ? '售后入库' : '未知'
                        }}
                    </template>
                </el-table-column>

            
                <el-table-column prop="product_id" label="产品ID"></el-table-column>
                <el-table-column prop="product_sku_id" label="产品SKUID"></el-table-column>
                <el-table-column prop="product_name" label="产品名称"></el-table-column>

                <el-table-column prop="product_price" label="产品价格">
                <template #default="{row}">
                    ¥{{ parseFloat(row.product_price).toFixed(2) }}
                </template>
                </el-table-column>

                <el-table-column prop="product_num" label="入库数量"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="spec_value" label="规格"></el-table-column>

                <el-table-column prop="file_path" label="图片">
                <template #default="{row}">
                    <el-image 
                    v-if="row.file_path"
                    :src="row.file_path" 
                    style="width: 50px; height: 50px"
                    :preview-src-list="[row.file_path]"
                    ></el-image>
                    <span v-else>无图片</span>
                </template>
                </el-table-column>

                <el-table-column prop="category_name" label="分类"></el-table-column>
                <el-table-column prop="create_time" label="入库时间"></el-table-column>
    
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>





      
  
    
    </div>
  </template>
  
  <script>
    import Warehouse_managementApi from '@/api/warehouse_management.js';
    import { changeDate } from '@/utils/index';
    import echarts from 'echarts';
    export default {
      components: {
     
      },
      inject: ['reload'],
      data() {
        return {
            selectData: '',
        pickerOptions: {
          disabledDate: (time) => {
            // 计算允许的最小日期（当前月前推6个月的第一天）
            const minDate = new Date()
            minDate.setMonth(minDate.getMonth() - 6)
            minDate.setDate(1)
            minDate.setHours(0, 0, 0, 0)

            // 计算允许的最大日期（当前月最后一天）
            const maxDate = new Date()
            maxDate.setMonth(maxDate.getMonth() + 1, 0)
            maxDate.setHours(23, 59, 59, 999)

            // 禁用不在时间范围内的日期
            return time < minDate || time > maxDate
          }
        },
        echarts2_option: {
          color: ['#FF6B6B', '#4ECDC4', '#edff68'], // 调整为三色系
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let tip = params[0].name + '<br/>';
              params.forEach(item => {
                tip += `${item.marker} ${item.seriesName}: ${item.value}<br/>`;
              });
              return tip;
            }
          },
          legend: {
            data: ['进货量'] // 对应接口返回的字段
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: '#f7f7f7',
                width: 2
              }
            },
            data: [] // 绑定月份数据
          },
          yAxis: {
            type: 'value',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: {
              color: '#333',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                type: 'dotted',
                color: '#DDDDDD'
              }
            }
          },
          series: [
            {
              name: '进货量',
              type: 'line',
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255,107,107,0.6)' },
                  { offset: 1, color: 'rgba(255,107,107,0.05)' }
                ])
              },
              data: []
            }
  
          ]
        },
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*搜索表单对象*/
          form: {},
          form_s:{
            shopValue: '',
            timeType: '3',
            time: [new Date(), new Date()],
            Mtime: '',
            supply_id:0,
            t_supply_id:0,
            product_sku_id:0,
          },
          formInline: {
            search:"",
            numb:"",
            create_time:"",
            kw:""
          },
  
          open_add:false,
          open_edit:false,
          warehouse_management_id:"",
          dialogVisible:false,
          open_detail:false,
  
  
          open_upload:false,
          // 导入类型
          import_type:'warehouse_management',

          supplyArr:[],
          productArr:[],
          notesRecord:{
            total_num:0
          }
        };
      },
      mounted() {
        
        window.addEventListener('resize', this.initchart);
        },
      created() {
        this.getSupply();
        this.getRecord();
        /*获取列表*/
        this.getTableList();
      },
      methods: {
        selectType(){

        this.getRecord();
        this.getTableList();
        },
        getSupply(){
            let self = this;
    
            self.loading = true;
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
                self.loading = false;
                
                self.supplyArr = data.data.supply
                self.productArr =  data.data.product
                self.form_s.supply_id = self.supplyArr[0].supply_id
                self.form_s.t_supply_id = self.supplyArr[0].supply_id
                self.form_s.product_sku_id = self.productArr[0].product_sku_id
                })
                .catch(error => {
                });
        },
        changeStore() {
    
         this.getRecord();
            this.getTableList();
      },
      initchart() {

            let myChart2 = echarts.init(document.getElementById('zhentiEch'));

            myChart2.resize();

        },
      getRecord(){
        let self = this;
          window.addEventListener('resize', this.initchart);
    
          let startTime = '';
          let endTime = '';
          if (this.form_s.time) {
            startTime = changeDate(this.form_s.time[0]);
            endTime = changeDate(this.form_s.time[1]);
          }


          let Params = {
            supply_id:self.form_s.supply_id,
            t_supply_id:self.form_s.t_supply_id,
            product_sku_id:self.form_s.product_sku_id,
            timeType:this.form_s.timeType,
            startTime,
            endTime,
          };

          self.loading = true;
          Warehouse_managementApi.getRecord(Params, true)
            .then(data => {
              self.loading = false;
              self.notesRecord = data.data.list.stats;
               self.echarts2_option.series[0].data = data.data.list.chart.series['进货量'];
      
           
              self.echarts2_option.xAxis.data =data.data.list.chart.xAxis;
              self.zhentiEch();



            })
            .catch(error => {
            });

      },
      zhentiEch() {
        let myChart = echarts.init(document.getElementById('zhentiEch'));
        myChart.setOption(this.echarts2_option, true);
      },
      getData(){
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange(val) {
          this.curPage = val;
          this.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
        //   let Params = this.formInline;
        //   Params.page = self.curPage;
        //   Params.list_rows = self.pageSize;
        let startTime = '';
          let endTime = '';
          if (this.form_s.time) {
            startTime = changeDate(this.form_s.time[0]);
            endTime = changeDate(this.form_s.time[1]);
          }


          let Params = {
            supply_id:self.form_s.supply_id,
            page : self.curPage,
            list_rows : self.pageSize,
            t_supply_id:self.form_s.t_supply_id,
            product_sku_id:self.form_s.product_sku_id,
            timeType:this.form_s.timeType,
            startTime,
            endTime,
          };
          self.loading = true;
          Warehouse_managementApi.record(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
  
   
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/warehouse_management/index/record.vue